import React from 'react'
import { Icon } from 'antd-mobile'
import './index.scss'
import { Callback } from 'antd-mobile/lib/modal/PropsType'

interface Props {
  imgSrc: string
  closeFun: any
}

function ImageModal({ imgSrc, closeFun }: Props) {
  return (
    <div className='c-image-modal'>
      <div className='mask-layer' onClick={closeFun}>
        <span className='icon'>
          <Icon type='cross-circle' color='#fff' />
        </span>
      </div>
      <div className='image-content'>
        <img src={imgSrc} alt='picture' className='image' />
      </div>
    </div>
  )
}

export default ImageModal
